import { BaseModel } from '../../../models'
import { TestExecution } from '../test-execution'

export class TestDefinition extends BaseModel {

  public criteria: {} = {}
  public definitionJwt: string = ''
  public name: string = ''
  public notes: string = ''
  public testExecutions: TestExecution[] = []

  public get data(){
    const JWTpiece = this.definitionJwt.split instanceof Function ? this.definitionJwt.split('.')[1] : ''
    const token =  !!JWTpiece ? JSON.parse(atob(JWTpiece)) : {'mp_properties': []}
    return token['mp_properties']['questions'] || []
  }

  public toJson() {
    return {
      id: this.id,
      criteria: this.criteria,
      definitionJwt: this.definitionJwt,
      name: this.name,
      notes: this.notes,
      testExecutions: this.testExecutions
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test-definition/test-definition.ts